import { render } from "./off-canvas-navbar.vue?vue&type=template&id=4200923b&ts=true"
import script from "./off-canvas-navbar.vue?vue&type=script&lang=ts"
export * from "./off-canvas-navbar.vue?vue&type=script&lang=ts"

import "./off-canvas-navbar.vue?vue&type=style&index=0&id=4200923b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__